<template>
  <van-tabbar v-model="tabActive" @change="tabChange" class="home-tabbars-view">
    <van-tabbar-item
      v-for="(item, index) in tabs"
      :key="index"
      :to="item.route"
      replace
    >
      <span>{{ item.title }}</span>
      <img
        slot="icon"
        :src="tabActive === index ? item.iconSelected : item.iconUnSelected"
        alt=""
      />
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  model: {
    prop: "currentTab",
    event: "onChange"
  },
  props: {
    currentTab: {
      type: Number,
      default: 0
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabActive: null
    };
  },
  created() {
    this.tabActive = this.currentTab;
  },
  methods: {
    setCurrentTab(tab) {
      this.tabActive = tab;
    },
    tabChange(tab) {
      this.$emit("onChange", tab);
    }
  }
};
</script>

<style lang="less">
.home-tabbars-view {
  height: @tabbar-height;
  font-size: 0.8rem;
  .home-tab-view .van-tabbar-item {
    font-size: 0.88rem;
  }
  .home-tab-view .van-tabbar-item .van-tabbar-item__text {
    margin-top: 0.3rem;
  }

  .van-tabbar-item--active {
    color: #23aff9;
  }
}
</style>
